import React from "react";
import PropTypes from "prop-types";
import { AdvancedButton } from "components/Buttons";
import { PublicViewSettingsForm, ReorganizeRoleForm, RoleForm, RolePublishModal } from "components/Missions/Roles";
import { useMissionRoles, useAuth } from "hooks";

/**
 * RoleAdvancedOptions
 *
 * @param {Object}  data
 * @param {Boolean} loading
 */
const RoleAdvancedOptions = ({ data, loading }) => {
  const { isAdmin } = useAuth();
  const {
    showForm,
    setShowForm,
    showReorganizeForm,
    setShowReorganizeForm,
    getAdvancedOptions,
    showPublicViewForm,
    setShowPublicViewForm,
    showPublishModal,
    setShowPublishModal,
    publishRole,
    shouldNotifySubscribers,
    setShouldNotifySubscribers,
    handleConfirmPublishRole,
    publishing,
    selectedRole,
  } = useMissionRoles({ skipQuery: true });

  if (!isAdmin) return null;

  return (
    <>
      <AdvancedButton options={getAdvancedOptions(data)} disabled={loading} />
      <RoleForm show={showForm} onClose={() => setShowForm(false)} isEditing={true} data={data} />
      <ReorganizeRoleForm show={showReorganizeForm} onClose={() => setShowReorganizeForm(false)} role={selectedRole} />
      <PublicViewSettingsForm show={showPublicViewForm} onClose={() => setShowPublicViewForm(false)} data={data} />
      <RolePublishModal
        show={showPublishModal}
        onClose={() => setShowPublishModal(false)}
        onSubmit={handleConfirmPublishRole}
        role={publishRole}
        shouldNotifySubscribers={shouldNotifySubscribers}
        setShouldNotifySubscribers={setShouldNotifySubscribers}
        loading={publishing}
      />
    </>
  );
};

RoleAdvancedOptions.propTypes = {
  data: PropTypes.object,
  loading: PropTypes.bool,
};

export default RoleAdvancedOptions;
